module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_sk_slovak-10df93d5bbac5915911a1ca01f9c6288.svg";